module.exports = __webpack_public_path__ + "static/media/S (70).7c580b5f.jpg";